/* Funções pequenas usadas em toda parte: escapar HTML, datas, tamanho de arquivo. */
export const $  = s => document.querySelector(s);
export const $$ = s => document.querySelectorAll(s);

export const esc=s=>String(s??"").replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
export const hoje=()=>new Date().toISOString().slice(0,10);
export const dataBR=iso=>{ if(!iso) return "\u2014"; const p=String(iso).slice(0,10).split("-"); return p.length===3?`${p[2]}/${p[1]}/${p[0].slice(2)}`:String(iso); };
export function dias(iso){ if(!iso) return null; const n=Math.round((new Date(hoje()+"T00:00:00")-new Date(String(iso).slice(0,10)+"T00:00:00"))/86400000); return isNaN(n)?null:n; }
export const idade=n=>n==null?"a0":n>60?"a2":n>30?"a1":"a0";
export const kb=b=>b<1024?b+" B":b<1048576?(b/1024).toFixed(0)+" KB":(b/1048576).toFixed(1)+" MB";
export const limpaNome=s=>String(s||"arquivo").normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-zA-Z0-9._-]/g,"-").slice(-80);
/* Le um arquivo como data URL, e carrega uma imagem a partir dela.
   Moram aqui, e nao na camada de arquivos, porque o portal do cliente usa
   os dois sem nunca falar com o banco: deixar em arquivos.js arrastava o
   cliente do Supabase inteiro para dentro do pacote do portal. */
export const lerURL=f=>new Promise((res,rej)=>{ const r=new FileReader(); r.onload=()=>res(r.result); r.onerror=rej; r.readAsDataURL(f); });
export const carregarImg=u=>new Promise((res,rej)=>{ const i=new Image(); i.onload=()=>res(i); i.onerror=rej; i.src=u; });

/* Copia texto para a área de transferência e responde se conseguiu.
   O plano B existe porque dentro de WebView, ou em página sem HTTPS, o
   navegador recusa a forma moderna sem avisar direito. */
export function copiarTexto(txt){
  return new Promise(resolve=>{
    const planoB=()=>{
      const ta=document.createElement("textarea");
      ta.value=txt; ta.style.cssText="position:fixed;opacity:0";
      document.body.appendChild(ta); ta.select();
      let ok=false;
      try{ ok=document.execCommand("copy"); }catch(e){ ok=false; }
      document.body.removeChild(ta); resolve(ok);
    };
    if(navigator.clipboard?.writeText) navigator.clipboard.writeText(txt).then(()=>resolve(true)).catch(planoB);
    else planoB();
  });
}
/* Mensagem flutuante no rodapé. */
export function toast(t){
  const el=$("#toast"); if(!el) return;
  el.textContent=t; el.classList.add("on");
  clearTimeout(toast.t); toast.t=setTimeout(()=>el.classList.remove("on"),2800);
}
/* Indicador de conexão no cabeçalho. */
export function live(on,txt){
  $("#live")?.classList.toggle("on",!!on);
  const t=$("#liveTxt"); if(t) t.textContent=txt;
}
